/* eslint-disable @next/next/link-passhref */
import React, { useEffect, Fragment } from "react";
import { useRouter } from "next/router";
import { useRecoilValue } from "recoil";
import clsx from "clsx";
import MuxPlayer from "@mux/mux-player-react";
import MuxLive from "../Video/MuxLive";

import { engageState } from "../../atoms/platform";

import useVideoFilter from "../../lib/hooks/useVideoFilter";

import { Tab } from "@headlessui/react";
import { Transition, Listbox } from "@headlessui/react";
import { SelectorIcon, CheckIcon } from "@heroicons/react/solid";
import { MdFilterList } from "react-icons/md";

// import Loading from "../Shared/Loading";

import UserWayWidget from "../UserWayWidget";

const dates = [
  { name: "2027", id: "2027" },
  { name: "2026", id: "2026" },
  { name: "2025", id: "2025" },
  { name: "2024", id: "2024" },
  { name: "2023", id: "2023" },
  { name: "2022", id: "2022" },
  { name: "2021", id: "2021" },
  { name: "2020", id: "2020" },
  { name: "2019", id: "2019" },
  { name: "2018", id: "2018" },
  { name: "2017", id: "2017" },
  { name: "2016", id: "2016" },
  { name: "2015", id: "2015" },
  { name: "2014", id: "2014" },
  { name: "2013", id: "2013" },
  { name: "2012", id: "2012" },
  { name: "2011", id: "2011" },
  { name: "2010", id: "2010" },
  { name: "2009", id: "2009" },
  { name: "2008", id: "2008" },
  { name: "2007", id: "2007" },
  { name: "2006", id: "2006" },
  { name: "2005", id: "2005" },
];

const Videos = () => {
  const router = useRouter();
  const { client } = router.query;
  const {
    videoDispatch,
    videos,
    filterText,
    liveFeed,
    showLive,
    selectedDate,
  } = useVideoFilter();
  const platform = useRecoilValue(engageState);

  useEffect(() => {
    if (client) {
      // fetchVideos();
      videoDispatch({ type: "FETCH_DATA", client });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  return (
    <div className="py-4">
      {/* All Meetings */}
      {client === "grapevinetx" ? (
        <Tab.Group
          className="relative 2xl:max-w-7xl 2xl:mx-auto overflow-y-auto pb-40"
          as="div"
          onChange={(e) => {
            videoDispatch({ type: "TAB", value: e, client });
          }}
        >
          <Tab.List className="flex">
            <Tab
              className={({ selected }) =>
                clsx(
                  "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-semibold rounded-t-md",
                  "focus:outline-none",
                  selected
                    ? "bg-blue-800 text-white"
                    : "hover:bg-zinc-400 border border-coolGray-700 text-black",
                )
              }
            >
              Live Stream
            </Tab>
            <Tab
              className={({ selected }) =>
                clsx(
                  "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-semibold rounded-t-md",
                  "focus:outline-none",
                  selected
                    ? "bg-blue-800 text-white"
                    : "hover:bg-zinc-400 border border-coolGray-700 text-black",
                )
              }
            >
              P&Z Stream
            </Tab>

            <Tab
              className={({ selected }) =>
                clsx(
                  "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-semibold rounded-t-md",
                  "focus:outline-none",
                  selected
                    ? "bg-blue-800 text-white"
                    : "hover:bg-zinc-400 border border-coolGray-700 text-black",
                )
              }
            >
              City Council
            </Tab>
            <Tab
              className={({ selected }) =>
                clsx(
                  "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-semibold rounded-t-md",
                  "focus:outline-none",
                  selected
                    ? "bg-blue-800 text-white"
                    : "hover:bg-zinc-400 border border-coolGray-700 text-black",
                )
              }
            >
              Boards and Commissions
            </Tab>
          </Tab.List>
          <Tab.Panels>
            <Tab.Panel>
              <div className="w-full flex items-center justify-center mb-4 mt-8">
                <div className="relative h-[221px] w-[375px] md:h-[336px] md:w-[598px] lg:h-[433px] lg:w-[770px]">
                  <MuxPlayer
                    streamType="live"
                    src="https://grapevinetx.cablecast.tv/live/stream-1/live.m3u8"
                    autoPlay
                    muted
                    accentColor="#3C096C"
                    onClick={(e) => e.stopPropogation()}
                  />
                </div>
              </div>
              <div className="flex justify-center mb-4 italic font-light">
                <p>Live Stream powered by Cablecast</p>
              </div>
            </Tab.Panel>
            <Tab.Panel>
              <div className="w-full flex items-center justify-center mb-4 mt-8">
                <div className="relative h-[221px] w-[375px] md:h-[336px] md:w-[598px] lg:h-[433px] lg:w-[770px]">
                  <MuxLive
                    agenda={{ meetingType: "Planning Commission" }}
                    playbackId="my00Nq6CJDMahRhSUHjwsKaPtCf02Rynzu"
                    platform={platform}
                    placeholderUrl="https://firebasestorage.googleapis.com/v0/b/fast-archive-274904.appspot.com/o/grapevinetx%2Flogo%2Fcity%20logo.png?alt=media&token=4c621108-70f0-4582-aa6f-6f2309e46a50"
                  />
                </div>
              </div>
              <div className="flex justify-center mb-4 italic font-light">
                <p>Live Stream powered by JustMeetings Media</p>
              </div>
            </Tab.Panel>

            <Tab.Panel className="overflow-y-auto min-h-96">
              <div className="flex w-full justify-between items-end mt-2 mb-6 space-x-1">
                <div className="flex flex-col w-1/2 lg:w-1/4">
                  <p className="italic text-black">Year:</p>
                  <Listbox
                    value={selectedDate}
                    onChange={(e) =>
                      videoDispatch({ type: "SET_DATE", payload: e, client })
                    }
                  >
                    {({ open }) => (
                      <>
                        <div className="relative mt-1">
                          <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white border border-gray-300 rounded-lg shadow-md cursor-default focus:outline-none sm:text-sm">
                            <span className="block truncate">
                              {selectedDate.name}
                            </span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                              <SelectorIcon
                                className="w-5 h-5 text-black"
                                aria-hidden="true"
                              />
                            </span>
                          </Listbox.Button>
                          <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <Listbox.Options
                              static
                              className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                            >
                              {dates?.map((person, personIdx) => (
                                <Listbox.Option
                                  key={personIdx}
                                  className={({ active }) =>
                                    `${
                                      active
                                        ? "text-blue-900 bg-blue-100"
                                        : "text-gray-900"
                                    }
                            cursor-default select-none relative py-2 pl-10 pr-4`
                                  }
                                  value={person}
                                >
                                  {({ selected, active }) => (
                                    <>
                                      <span
                                        className={`${
                                          selected
                                            ? "font-medium"
                                            : "font-normal"
                                        } block truncate`}
                                      >
                                        {person.name}
                                      </span>
                                      {selected ? (
                                        <span
                                          className={`${
                                            active
                                              ? "text-blue-600"
                                              : "text-blue-600"
                                          }
                                  absolute inset-y-0 left-0 flex items-center pl-3`}
                                        >
                                          <CheckIcon
                                            className="w-5 h-5"
                                            aria-hidden="true"
                                          />
                                        </span>
                                      ) : null}
                                    </>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
                <div className="flex items-center w-1/2 lg:w-1/4">
                  <MdFilterList className="h-5 w-5 text-gray-500" />
                  <input
                    type="search"
                    value={filterText}
                    onChange={(e) =>
                      videoDispatch({
                        type: "FILTER_DATE",
                        payload: e.target.value,
                      })
                    }
                    className="w-full bg-transparent text-black text-xs lg:text-sm placeholder:text-zinc-400 border border-b-blue-600 border-t-transparent border-r-transparent border-l-transparent focus:outline-none active:outline-none active:border-t-transparent"
                    placeholder="Type Date to Filter"
                  />
                </div>
              </div>

              {videos?.map((video, i) => (
                <>
                  {video.pdfOnly ? (
                    <a
                      href={`${process.env.NEXT_PUBLIC_BASE_URL}/tv/basic/vod/${client}/${video._id}`}
                      target="_blank"
                      rel="noreferrer"
                      key={video._id}
                    >
                      <div
                        className={clsx(
                          "px-4 2xl:px-6 my-2 text-black select-none flex flex-col sm:flex-row justify-between border-b border-zinc-700",
                        )}
                      >
                        <p
                          className={clsx(
                            "cursor-pointer hover:text-blue-900 text-blue-700",
                            "text-mobile sm:text-sm lg:text-base font-medium inline-flex text-black truncate",
                          )}
                        >
                          {video.meetingType}
                        </p>
                        <p className="text-mobile sm:text-sm lg:text-base truncate">
                          {video.scheduleDate}
                        </p>
                      </div>
                    </a>
                  ) : (
                    <a
                      href={`${process.env.NEXT_PUBLIC_BASE_URL}/player/${client}/${video._id}`}
                      target="_blank"
                      rel="noreferrer"
                      key={video._id}
                    >
                      <div
                        className={clsx(
                          "px-4 2xl:px-6 my-2 text-black select-none flex flex-col sm:flex-row justify-between border-b border-zinc-700",
                        )}
                      >
                        <p
                          className={clsx(
                            "cursor-pointer hover:text-blue-900 text-blue-700",
                            "text-mobile sm:text-sm lg:text-base font-medium inline-flex text-black truncate",
                          )}
                        >
                          {video.meetingType}
                        </p>
                        <p className="text-mobile sm:text-sm lg:text-base truncate">
                          {video.scheduleDate}
                        </p>
                      </div>
                    </a>
                  )}
                </>
              ))}
            </Tab.Panel>
            <Tab.Panel className="overflow-y-auto min-h-96">
              <div className="flex w-full justify-between items-end mt-2 mb-6">
                <div className="flex flex-col w-1/4">
                  <p className="italic text-black">Year:</p>
                  <Listbox
                    value={selectedDate}
                    onChange={(e) =>
                      videoDispatch({ type: "SET_DATE", payload: e, client })
                    }
                  >
                    {({ open }) => (
                      <>
                        <div className="relative mt-1">
                          <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white border border-gray-300 rounded-lg shadow-md cursor-default focus:outline-none sm:text-sm">
                            <span className="block truncate">
                              {selectedDate.name}
                            </span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                              <SelectorIcon
                                className="w-5 h-5 text-black"
                                aria-hidden="true"
                              />
                            </span>
                          </Listbox.Button>
                          <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <Listbox.Options
                              static
                              className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                            >
                              {dates?.map((person, personIdx) => (
                                <Listbox.Option
                                  key={personIdx}
                                  className={({ active }) =>
                                    `${
                                      active
                                        ? "text-blue-900 bg-blue-100"
                                        : "text-gray-900"
                                    }
                            cursor-default select-none relative py-2 pl-10 pr-4`
                                  }
                                  value={person}
                                >
                                  {({ selected, active }) => (
                                    <>
                                      <span
                                        className={`${
                                          selected
                                            ? "font-medium"
                                            : "font-normal"
                                        } block truncate`}
                                      >
                                        {person.name}
                                      </span>
                                      {selected ? (
                                        <span
                                          className={`${
                                            active
                                              ? "text-blue-600"
                                              : "text-blue-600"
                                          }
                                  absolute inset-y-0 left-0 flex items-center pl-3`}
                                        >
                                          <CheckIcon
                                            className="w-5 h-5"
                                            aria-hidden="true"
                                          />
                                        </span>
                                      ) : null}
                                    </>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
                <div className="flex items-center w-1/4">
                  <MdFilterList className="h-5 w-5 text-gray-500" />
                  <input
                    type="search"
                    value={filterText}
                    onChange={(e) =>
                      videoDispatch({
                        type: "FILTER_DATE",
                        payload: e.target.value,
                      })
                    }
                    className="w-full bg-transparent text-black text-sm placeholder:text-zinc-400 border border-b-blue-600 border-t-transparent border-r-transparent border-l-transparent focus:outline-none active:outline-none active:border-t-transparent"
                    placeholder="Type Date for Quick Filter"
                  />
                </div>
              </div>
              {videos?.map((video, i) => (
                <>
                  {video.pdfOnly ? (
                    <a
                      href={`${process.env.NEXT_PUBLIC_BASE_URL}/tv/basic/vod/${client}/${video._id}`}
                      target="_blank"
                      rel="noreferrer"
                      key={video._id}
                    >
                      <div
                        className={clsx(
                          "px-4 2xl:px-6 my-2 text-black select-none flex flex-col sm:flex-row justify-between border-b border-zinc-700",
                        )}
                      >
                        <p
                          className={clsx(
                            "cursor-pointer hover:text-blue-900 text-blue-700",
                            "text-mobile sm:text-sm lg:text-base font-medium inline-flex text-black truncate",
                          )}
                        >
                          {video.meetingType}
                        </p>
                        <p className="text-mobile sm:text-sm lg:text-base truncate">
                          {video.scheduleDate}
                        </p>
                      </div>
                    </a>
                  ) : (
                    <a
                      href={`${process.env.NEXT_PUBLIC_BASE_URL}/player/${client}/${video._id}`}
                      target="_blank"
                      rel="noreferrer"
                      key={video._id}
                    >
                      <div
                        className={clsx(
                          "px-4 2xl:px-6 my-2 text-black select-none flex flex-col sm:flex-row justify-between border-b border-zinc-700",
                        )}
                      >
                        <p
                          className={clsx(
                            "cursor-pointer hover:text-blue-900 text-blue-700",
                            "text-mobile sm:text-sm lg:text-base font-medium inline-flex text-black truncate",
                          )}
                        >
                          {video.meetingType}
                        </p>
                        <p className="text-mobile sm:text-sm lg:text-base truncate">
                          {video.scheduleDate}
                        </p>
                      </div>
                    </a>
                  )}
                </>
              ))}
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      ) : (
        <Tab.Group
          className="relative 2xl:max-w-7xl 2xl:mx-auto overflow-y-auto pb-40"
          as="div"
          onChange={(e) => {
            videoDispatch({ type: "TAB", value: e, client });
          }}
        >
          <Tab.List className="flex">
            {/* TODO add tab for grapevine secondary live stream */}
            {showLive && (
              <Tab
                className={({ selected }) =>
                  clsx(
                    "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-semibold rounded-t-md",
                    "focus:outline-none",
                    selected
                      ? "bg-blue-800 text-white"
                      : "hover:bg-zinc-400 border border-coolGray-700 text-black",
                  )
                }
              >
                Live Stream
              </Tab>
            )}
            <Tab
              className={({ selected }) =>
                clsx(
                  "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-semibold rounded-t-md",
                  "focus:outline-none",
                  selected
                    ? "bg-blue-800 text-white"
                    : "hover:bg-zinc-400 border border-coolGray-700 text-black",
                )
              }
            >
              City Council
            </Tab>
            <Tab
              className={({ selected }) =>
                clsx(
                  "w-full py-1.5 2xl:py-2.5 text-mini xl:text-sm 2xl:text-base leading-5 font-semibold rounded-t-md",
                  "focus:outline-none",
                  selected
                    ? "bg-blue-800 text-white"
                    : "hover:bg-zinc-400 border border-coolGray-700 text-black",
                )
              }
            >
              Boards and Commissions
            </Tab>
          </Tab.List>
          <Tab.Panels>
            {showLive && (
              <Tab.Panel>
                <div className="w-full flex items-center justify-center mb-4 mt-8">
                  <div className="relative h-[221px] w-[375px] md:h-[336px] md:w-[598px] lg:h-[433px] lg:w-[770px]">
                    <iframe
                      className="trms-player absolute inset-0 w-full h-full"
                      type="text/html"
                      // width="360"
                      // height="240"
                      src={liveFeed}
                      webkitAllowFullScreen
                      mozallowfullscreen
                      allowFullScreen
                      frameBorder="0"
                    ></iframe>
                  </div>
                </div>
                <div className="flex justify-center mb-4 italic font-light">
                  <p>Live Stream powered by Cablecast</p>
                </div>
              </Tab.Panel>
            )}
            <Tab.Panel className="overflow-y-auto min-h-96">
              <div className="flex w-full justify-between items-end mt-2 mb-6">
                <div className="flex flex-col w-1/4">
                  <p className="italic text-black">Year:</p>
                  <Listbox
                    value={selectedDate}
                    onChange={(e) =>
                      videoDispatch({ type: "SET_DATE", payload: e, client })
                    }
                  >
                    {({ open }) => (
                      <>
                        <div className="relative mt-1">
                          <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white border border-gray-300 rounded-lg shadow-md cursor-default focus:outline-none sm:text-sm">
                            <span className="block truncate">
                              {selectedDate.name}
                            </span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                              <SelectorIcon
                                className="w-5 h-5 text-black"
                                aria-hidden="true"
                              />
                            </span>
                          </Listbox.Button>
                          <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <Listbox.Options
                              static
                              className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                            >
                              {dates?.map((person, personIdx) => (
                                <Listbox.Option
                                  key={personIdx}
                                  className={({ active }) =>
                                    `${
                                      active
                                        ? "text-blue-900 bg-blue-100"
                                        : "text-gray-900"
                                    }
                            cursor-default select-none relative py-2 pl-10 pr-4`
                                  }
                                  value={person}
                                >
                                  {({ selected, active }) => (
                                    <>
                                      <span
                                        className={`${
                                          selected
                                            ? "font-medium"
                                            : "font-normal"
                                        } block truncate`}
                                      >
                                        {person.name}
                                      </span>
                                      {selected ? (
                                        <span
                                          className={`${
                                            active
                                              ? "text-blue-600"
                                              : "text-blue-600"
                                          }
                                  absolute inset-y-0 left-0 flex items-center pl-3`}
                                        >
                                          <CheckIcon
                                            className="w-5 h-5"
                                            aria-hidden="true"
                                          />
                                        </span>
                                      ) : null}
                                    </>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
                <div className="flex items-center w-1/4">
                  <MdFilterList className="h-5 w-5 text-gray-500" />
                  <input
                    type="search"
                    value={filterText}
                    onChange={(e) =>
                      videoDispatch({
                        type: "FILTER_DATE",
                        payload: e.target.value,
                      })
                    }
                    className="w-full bg-transparent text-black text-sm placeholder:text-zinc-400 border border-b-blue-600 border-t-transparent border-r-transparent border-l-transparent focus:outline-none active:outline-none active:border-t-transparent"
                    placeholder="Type Date for Quick Filter"
                  />
                </div>
              </div>

              {videos?.map((video, i) => (
                <>
                  {video.pdfOnly ? (
                    <a
                      href={`${process.env.NEXT_PUBLIC_BASE_URL}/tv/basic/vod/${client}/${video._id}`}
                      target="_blank"
                      rel="noreferrer"
                      key={video._id}
                    >
                      <div
                        className={clsx(
                          "px-4 2xl:px-6 my-2 text-black select-none flex flex-col sm:flex-row justify-between border-b border-zinc-700",
                        )}
                      >
                        <p
                          className={clsx(
                            "cursor-pointer hover:text-blue-900 text-blue-700",
                            "text-mobile sm:text-sm lg:text-base font-medium inline-flex text-black truncate",
                          )}
                        >
                          {video.meetingType}
                        </p>
                        <p className="text-mobile sm:text-sm lg:text-base truncate">
                          {video.scheduleDate}
                        </p>
                      </div>
                    </a>
                  ) : (
                    <a
                      href={`${process.env.NEXT_PUBLIC_BASE_URL}/player/${client}/${video._id}`}
                      target="_blank"
                      rel="noreferrer"
                      key={video._id}
                    >
                      <div
                        className={clsx(
                          "px-4 2xl:px-6 my-2 text-black select-none flex flex-col sm:flex-row justify-between border-b border-zinc-700",
                        )}
                      >
                        <p
                          className={clsx(
                            "cursor-pointer hover:text-blue-900 text-blue-700",
                            "text-mobile sm:text-sm lg:text-base font-medium inline-flex text-black truncate",
                          )}
                        >
                          {video.meetingType}
                        </p>
                        <p className="text-mobile sm:text-sm lg:text-base truncate">
                          {video.scheduleDate}
                        </p>
                      </div>
                    </a>
                  )}
                </>
              ))}
            </Tab.Panel>
            <Tab.Panel className="overflow-y-auto min-h-96">
              <div className="flex w-full justify-between items-end mt-2 mb-6">
                <div className="flex flex-col w-1/4">
                  <p className="italic text-black">Year:</p>
                  <Listbox
                    value={selectedDate}
                    onChange={(e) =>
                      videoDispatch({ type: "SET_DATE", payload: e, client })
                    }
                  >
                    {({ open }) => (
                      <>
                        <div className="relative mt-1">
                          <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white border border-gray-300 rounded-lg shadow-md cursor-default focus:outline-none sm:text-sm">
                            <span className="block truncate">
                              {selectedDate.name}
                            </span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                              <SelectorIcon
                                className="w-5 h-5 text-black"
                                aria-hidden="true"
                              />
                            </span>
                          </Listbox.Button>
                          <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <Listbox.Options
                              static
                              className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                            >
                              {dates?.map((person, personIdx) => (
                                <Listbox.Option
                                  key={personIdx}
                                  className={({ active }) =>
                                    `${
                                      active
                                        ? "text-blue-900 bg-blue-100"
                                        : "text-gray-900"
                                    }
                            cursor-default select-none relative py-2 pl-10 pr-4`
                                  }
                                  value={person}
                                >
                                  {({ selected, active }) => (
                                    <>
                                      <span
                                        className={`${
                                          selected
                                            ? "font-medium"
                                            : "font-normal"
                                        } block truncate`}
                                      >
                                        {person.name}
                                      </span>
                                      {selected ? (
                                        <span
                                          className={`${
                                            active
                                              ? "text-blue-600"
                                              : "text-blue-600"
                                          }
                                  absolute inset-y-0 left-0 flex items-center pl-3`}
                                        >
                                          <CheckIcon
                                            className="w-5 h-5"
                                            aria-hidden="true"
                                          />
                                        </span>
                                      ) : null}
                                    </>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
                <div className="flex items-center w-1/4">
                  <MdFilterList className="h-5 w-5 text-gray-500" />
                  <input
                    type="search"
                    value={filterText}
                    onChange={(e) =>
                      videoDispatch({
                        type: "FILTER_DATE",
                        payload: e.target.value,
                      })
                    }
                    className="w-full bg-transparent text-black text-sm placeholder:text-zinc-400 border border-b-blue-600 border-t-transparent border-r-transparent border-l-transparent focus:outline-none active:outline-none active:border-t-transparent"
                    placeholder="Type Date for Quick Filter"
                  />
                </div>
              </div>
              {videos?.map((video, i) => (
                <>
                  {video.pdfOnly ? (
                    <a
                      href={`${process.env.NEXT_PUBLIC_BASE_URL}/tv/basic/vod/${client}/${video._id}`}
                      target="_blank"
                      rel="noreferrer"
                      key={video._id}
                    >
                      <div
                        className={clsx(
                          "px-4 2xl:px-6 my-2 text-black select-none flex flex-col sm:flex-row justify-between border-b border-zinc-700",
                        )}
                      >
                        <p
                          className={clsx(
                            "cursor-pointer hover:text-blue-900 text-blue-700",
                            "text-mobile sm:text-sm lg:text-base font-medium inline-flex text-black truncate",
                          )}
                        >
                          {video.meetingType}
                        </p>
                        <p className="text-mobile sm:text-sm lg:text-base truncate">
                          {video.scheduleDate}
                        </p>
                      </div>
                    </a>
                  ) : (
                    <a
                      href={`${process.env.NEXT_PUBLIC_BASE_URL}/player/${client}/${video._id}`}
                      target="_blank"
                      rel="noreferrer"
                      key={video._id}
                    >
                      <div
                        className={clsx(
                          "px-4 2xl:px-6 my-2 text-black select-none flex flex-col sm:flex-row justify-between border-b border-zinc-700",
                        )}
                      >
                        <p
                          className={clsx(
                            "cursor-pointer hover:text-blue-900 text-blue-700",
                            "text-mobile sm:text-sm lg:text-base font-medium inline-flex text-black truncate",
                          )}
                        >
                          {video.meetingType}
                        </p>
                        <p className="text-mobile sm:text-sm lg:text-base truncate">
                          {video.scheduleDate}
                        </p>
                      </div>
                    </a>
                  )}
                </>
              ))}
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      )}
      <UserWayWidget />
    </div>
  );
};

export default Videos;
